"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeepgramTranscriberModel = void 0;
exports.DeepgramTranscriberModel = {
    Nova2: "nova-2",
    Nova2General: "nova-2-general",
    Nova2Meeting: "nova-2-meeting",
    Nova2Phonecall: "nova-2-phonecall",
    Nova2Finance: "nova-2-finance",
    Nova2Conversationalai: "nova-2-conversationalai",
    Nova2Voicemail: "nova-2-voicemail",
    Nova2Video: "nova-2-video",
    Nova2Medical: "nova-2-medical",
    Nova2Drivethru: "nova-2-drivethru",
    Nova2Automotive: "nova-2-automotive",
    Nova: "nova",
    NovaGeneral: "nova-general",
    NovaPhonecall: "nova-phonecall",
    NovaMedical: "nova-medical",
    Enhanced: "enhanced",
    EnhancedGeneral: "enhanced-general",
    EnhancedMeeting: "enhanced-meeting",
    EnhancedPhonecall: "enhanced-phonecall",
    EnhancedFinance: "enhanced-finance",
    Base: "base",
    BaseGeneral: "base-general",
    BaseMeeting: "base-meeting",
    BasePhonecall: "base-phonecall",
    BaseFinance: "base-finance",
    BaseConversationalai: "base-conversationalai",
    BaseVoicemail: "base-voicemail",
    BaseVideo: "base-video",
};
